import { useState, useEffect, useRef } from "react";
import { Package, TrendingUp, AlertTriangle, X, LinkIcon, Pencil } from "lucide-react";
import "./index.css";
import { useSelector } from "react-redux";
import { EditProductToSell } from "../ProductToSell";
import { Minus, Plus } from "lucide-react";
import SerialNumber from "./AddSerialNumber";

export const ProductToSellCard = ({ className, product, addToCart, removeFromCart, sellingCart, updateCartTotal }) => {
  const [selected, setSelected] = useState(false);
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [event, setEvent] = useState(null);
  const { user } = useSelector((state) => state.webStoreUser);
  let currency = user ? user.userCountryCurrencySymbol : "#";

  useEffect(() => {
    let newCart = sellingCart.filter((item) => item._id === product._id);
    if (newCart.length > 0) {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [sellingCart]);

  /* const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  }; */

  const getStockStatus = (stock, stockLimit) => {
    if (stock === 0) {
      return {
        status: "out",
        badgeClass: "pos-badge-out-of-stock",
        cardClass: "pos-card-out-of-stock",
        icon: X,
        label: "Out of Stock",
      };
    }
    if (stock <= stockLimit) {
      return {
        status: "low",
        badgeClass: "pos-badge-low-stock",
        cardClass: "pos-card-low-stock",
        icon: AlertTriangle,
        label: "Low Stock",
      };
    }
    return {
      status: "in-stock",
      badgeClass: "pos-badge-in-stock",
      cardClass: "pos-card-in-stock",
      icon: Package,
      label: "In Stock",
    };
  };
  const quantityAvailable = product.damagedAmount ? Number(product?.quantity) - Number(product?.damagedAmount) : product.quantity;

  const stockInfo = getStockStatus(quantityAvailable, product.stockLimit);
  const IconComponent = stockInfo.icon;

  const toggleState = (e) => {
    /*   selected ? setSelected(false) : setSelected(true)
          !selected && addToCart(product) */
    let targetDiv = e.target;

    if (selected) {
      setSelected(false);
      removeFromCart(product);
    } else {
      if (Number(product.quantity) - Number(product.damagedAmount ? product.damagedAmount : 0) > 0) {
        setOpenEditProduct(true);
      } else {
        targetDiv.style.animation = "shake 0.5s ease-in-out";
        targetDiv.addEventListener("animationend", () => {
          targetDiv.style.animation = "";
        });
      }
    }
  };

  return (
    <>
      <div
        style={
          selected
            ? {
                border: "2px solid rgb(89 190 224)",
                boxShadow: "0px 0px 5px 10px rgb(249, 249, 255)",
                transform: "scale(0.9)",
              }
            : {
                border: "none",
                boxShadow: "none",
                transform: "scale(1)",
              }
        }
        onClick={(e) => toggleState(e)}
        className={`pos-product-card ${stockInfo.cardClass} ${className || ""}`}
      >
        {/* Background pattern */}
        <div className={`pos-background-pattern pos-bg-${stockInfo.status}`} />
        {product.isSubUnitSold && <SubUnitTag unit={product.unit} />}

        {/* Stock status badge */}

        <div className='pos-badge-container'>
          <div className={`pos-stock-badge ${stockInfo.badgeClass}`}>
            <IconComponent className='pos-badge-icon' />
            {stockInfo.label}
          </div>
        </div>

        <div className='pos-card-content'>
          {/* Product name */}
          <div className='pos-product-title-section'>
            <h2 className='pos-product-name'>{product.name}</h2>
            <p>{product.brand}</p>
          </div>

          {/* Stats section */}
          <div className='pos-stats-section'>
            <div className='pos-stats-container'>
              {/* Stock info */}
              <div className='pos-stock-info'>
                <div className='pos-availability-row'>
                  <div className={`pos-stock-indicator pos-stock-dot-${stockInfo.status}`} />
                  <span className='pos-availability-text'>{quantityAvailable === 0 ? "Unavailable" : "Available"}</span>
                </div>
                <span className='pos-stock-number'>{quantityAvailable.toLocaleString()}</span>
                {quantityAvailable <= product.stockLimit && quantityAvailable > 0 && <span className='pos-reorder-alert'>Reorder Soon</span>}
              </div>

              {/* Price info */}
              <div className='pos-price-info'>
                {/* <div className='pos-price-label'>
                        <TrendingUp className='pos-price-icon' />
                        <span className='pos-price-label-text'>Unit Price</span>
                      </div> */}
                <div className='pos-price-display'>
                  <span className='pos-price-amount'>
                    {currency} {product.unitPrice.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hover overlay */}
        <div className='pos-hover-overlay' />
      </div>
      {openEditProduct && (
        /*  <EditProductToSell
          product={product}
          setOpenEditProduct={setOpenEditProduct}
          removeFromCart={removeFromCart}
          addToCart={addToCart}
          sellingCart={sellingCart}
          currency={currency}
          setSelected={setSelected}
          updateCartTotal={updateCartTotal}
        /> */
        <ProductOverlay product={product} setOpenEditProduct={setOpenEditProduct} setSelected={setSelected} addToCart={addToCart} currency={currency} />
      )}
    </>
  );
};

const ProductOverlay = ({ product, setOpenEditProduct, currency, setSelected, addToCart }) => {
  const [unitPrice, setUnitPrice] = useState(Number(product?.unitPrice ?? 0));
  const [quantity, setQuantity] = useState(Number(product?.quantity) - Number(product?.damagedAmount) === 0.5 ? 0.5 : 1);
  const [totalPrice, setTotalPrice] = useState(0);
  const [serialNumber, setSerialNumber] = useState("");
  const inputRef = useRef(null);

  let imageUrl = product?.productImage?.[0]
    ? `${product?.productImage[0].split("/upload/")[0]}/upload/f_auto,q_auto,w_140/${product?.productImage[0].split("/upload/")[1]}`
    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYvCeXDXg1bqQwpFgdPIgqDAdjK4gJpMCdRDCgBh_i2k4y-w-loRNB-bHpYsJCMt8y2i4&usqp=CAU";

  useEffect(() => {
    setTotalPrice(Number(unitPrice) * Number(quantity));
  }, [unitPrice, quantity]);

  const controlQuantityInput = (e) => {
    const raw = e.target.value;
    let cleanValue = Number(raw.replace(/^0+/, "") || "0");

    //enforce 0.5 steps
    const steppedValue = Math.round(cleanValue * 2) / 2;

    //bounds
    const max = Number(product?.quantity) - Number(product?.damagedAmount);

    if (cleanValue * 2 !== Math.round(cleanValue * 2)) return; //not a multiple of 0.5
    if (steppedValue < 0.5) {
      setQuantity(0.5);
    } else if (steppedValue > max) {
      console.log("here is greated");

      setQuantity(max);
    } else {
      setQuantity(steppedValue);
    }
  };

  const unWantedInputs = ["e", "E", "+", "-", "e+", "E+", "e-", "E-", "+-", "-+"];

  const handleAddRoCart = () => {
    inputRef.current.blur(); // ensure input is blurred on mobile before proceeding
    let targetDIv = document.querySelector(".product-overlay-content");
    let targetDiv2 = document.querySelector(".action-buttons");

    targetDiv2.style.opacity = "0";
    targetDIv.style.animation = "addToCart 0.5s ease-in-out";
    targetDIv.addEventListener("animationend", () => {
      targetDIv.style.animation = "";

      setOpenEditProduct(false);
      // check if unit price is empty or nan

      if (unitPrice === "" || isNaN(Number(unitPrice)) || Number(unitPrice) <= 0) {
        const unitPriceBlur = product.unitPrice;
        const totalPriceBlur = Number(unitPriceBlur) * Number(quantity);
        addToCart({
          ...product,
          totalPrice: totalPriceBlur,
          soldUnitPrice: totalPriceBlur,
          soldQuantity: quantity,
          serialNumber: serialNumber ? serialNumber : null,
        });
        setSelected(true);
        console.log("added with blur price");
      } else {
        addToCart({
          ...product,
          totalPrice: totalPrice ? totalPrice : Number(product.unitPrice) * quantity,
          soldUnitPrice: unitPrice ? Number(unitPrice) : Number(product.unitPrice),
          soldQuantity: quantity,
          serialNumber: serialNumber ? serialNumber : null,
        });
        setSelected(true);
        console.log("added with current price");
      }
    });
  };
  const allowDigits = (e) => {
    if (e.inputType?.startsWith("insert") && e.data && /[^0-9]/.test(e.data)) {
      e.preventDefault();
    }
  };
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <div className='product-overlay'>
      <div className='product-overlay-backdrop' onClick={() => setOpenEditProduct(false)} />
      <div className='product-overlay-content'>
        <div className='product-card'>
          {/* Product Image */}
          <div className='product-image'>
            <div className='product-placeholder'>
              <img src={imageUrl.toString()} className='js7sfbsd88' />
            </div>
          </div>

          {/* Product Details */}
          <div className='product-details'>
            <div className='product-brand'>{product.brand}</div>
            <div className='product-name'>{product.name}</div>
            <div className='product-total'>
              Total{" "}
              <span className='total-amount'>
                {currency} {totalPrice?.toLocaleString()}
              </span>
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px", alignItems: "center", flexDirection: "column", justifyContent: "space-between" }}>
            <div
              style={{
                padding: "6px 12px",
                background: unitPrice > product.costPrice ? "#dbeafe" : "#fee2e2",
                borderRadius: "8px",
                fontSize: "12px",
                fontWeight: "600",
                color: unitPrice > product.costPrice ? "#1e40af" : "#dc2626",
                whiteSpace: "nowrap",
                height: "fit-content",
              }}
            >
              {unitPrice > product.costPrice ? "↗ Profit" : "↘ Loss"}
            </div>
            <SerialNumber value={serialNumber} onChange={setSerialNumber} />
          </div>
        </div>

        {/* Price and Quantity Section */}
        <div className='price-quantity-section'>
          <div className='input-group'>
            <label className='input-label'>
              Unit Price (
              <span
                style={{
                  fontSize: "12px",
                  color: "rgb(85, 83, 83)",
                }}
              >
                click to edit
              </span>{" "}
              )
            </label>
            <div className='price-input-wrapper'>
              <span className='currency-symbol'>{currency} </span>
              {/*  <input
                ref={inputRef}
                key={isMobile ? "mobile" : "desktop"}
                type={isMobile ? "text" : "number"}
                inputMode='numeric' // shows numeric keyboard on mobile
                pattern={isMobile ? "[0-9]*" : undefined}
                onBeforeInput={isMobile ? allowDigits : undefined}
                value={unitPrice}
                onChange={(e) => {
                  const raw = e.target.value;
                  if (unWantedInputs.includes(e.nativeEvent.data)) return;

                  if (raw === "") {
                    setUnitPrice("");
                    return;
                  }

                  // 🚫 If not a number, revert to previous valid product price
                  if (isNaN(raw)) {
                    setUnitPrice(Number(product.unitPrice));
                    return;
                  }

                  //  setUnitPrice(Number(raw));
                  // ✅ Strip leading zeros and update
                  const cleanValue = Number(raw.replace(/^0+/, "") || "0");
                  setUnitPrice(cleanValue);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.target.blur(); // ensure blur fires
                }}
                onBlur={() => {
                  if (unitPrice === "" || unitPrice <= 0 || isNaN(unitPrice)) {
                    setUnitPrice(Number(product.unitPrice));
                  }
                }}
                onFocusOut={() => {
                  if (unitPrice === "" || unitPrice <= 0 || isNaN(unitPrice)) {
                    setUnitPrice(Number(product.unitPrice));
                  }
                }}
                className='price-input'
                placeholder={unitPrice?.toLocaleString()}
              /> */}

              <input
                ref={inputRef}
                key={isMobile ? "mobile" : "desktop"}
                type='text'
                inputMode='numeric'
                pattern='[0-9]*'
                value={unitPrice === "" || unitPrice === null || unitPrice === undefined ? "" : Number(unitPrice).toLocaleString("en-US")}
                onChange={(e) => {
                  // Remove commas and anything that isn't a digit
                  const raw = e.target.value.replace(/,/g, "").replace(/\D/g, "");

                  if (raw === "") {
                    setUnitPrice("");
                    return;
                  }

                  // Remove leading zeros
                  const cleanValue = raw.replace(/^0+/, "") || "0";

                  setUnitPrice(cleanValue);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.target.blur();
                  }
                }}
                onBlur={() => {
                  if (unitPrice === "" || Number(unitPrice) <= 0 || isNaN(Number(unitPrice))) {
                    setUnitPrice(Number(product.unitPrice));
                  }
                }}
                className='price-input'
                placeholder={Number(product.unitPrice)?.toLocaleString("en-US")}
              />

              <div className='help-icon'>
                <Pencil size={10} />
              </div>
            </div>
          </div>

          <div className='input-group'>
            <label className='input-label'>Quantity ({product.unit})</label>
            <div className='quantity-controls'>
              <button
                className='quantity-btn'
                onClick={() => {
                  if (product.quantity - product.damagedAmount === 0.5) {
                    setQuantity(0.5);
                    return;
                  }

                  setQuantity(quantity - 1 < 1 ? 1 : quantity - 1);
                }}
                disabled={quantity <= 1}
              >
                <Minus className='quantity-icon' />
              </button>
              <input
                key={isMobile ? "mobile" : "desktop"}
                type={isMobile ? "text" : "number"}
                inputMode='decimal' // shows numeric keyboard on mobile
                pattern={isMobile ? "[0-9]*" : undefined}
                onBeforeInput={isMobile ? allowDigits : undefined}
                value={quantity}
                onChange={(e) => {
                  const raw = e.target.value;
                  if (unWantedInputs.includes(e.nativeEvent.data)) return;
                  if (raw === "") {
                    setQuantity("");
                    return;
                  }
                  if (isNaN(raw)) {
                    setQuantity(1);
                    return;
                  }

                  controlQuantityInput(e);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.target.blur(); // ensure blur fires
                }}
                onBlur={() => {
                  if (quantity === "" || quantity <= 0 || isNaN(quantity)) {
                    setQuantity(1);
                  }
                }}
                onFocusOut={() => {
                  if (quantity === "" || quantity <= 0 || isNaN(quantity)) {
                    setQuantity(1);
                  }
                }}
                className='quantity-display'
              />

              <button
                className='quantity-btn'
                onClick={() => {
                  if (product.quantity - product.damagedAmount === 0.5) {
                    setQuantity(0.5);
                    return;
                  }

                  setQuantity(
                    quantity >= parseInt(product?.quantity) - parseInt(product?.damagedAmount)
                      ? parseInt(product?.quantity) - parseInt(product?.damagedAmount)
                      : quantity + 1,
                  );
                }}
              >
                <Plus className='quantity-icon' />
              </button>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className='action-buttons'>
          <button
            className='remove-btn'
            onClick={() => {
              setOpenEditProduct(false);
            }}
          >
            Cancel
          </button>
          <button className='confirm-btn' onClick={handleAddRoCart}>
            Add to cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductToSellCard;

const SubUnitTag = ({ unit }) => {
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "0.2rem",
          left: "0.3px",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)",
          border: "1px solid #ddd6fe",
          borderRadius: "7px",
          padding: "3px 8px 3px 6px",
          zIndex: 2,
        }}
      >
        {/* Stacked dots icon indicating hierarchy */}
        <div style={{ position: "relative", width: "14px", height: "14px", flexShrink: 0 }}>
          {/* Parent node */}
          <div
            style={{
              position: "absolute",
              top: "0.2rem",
              left: "3px",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              background: "#7c3aed",
              opacity: 0.35,
            }}
          />
          {/* Child connector */}
          <div
            style={{
              position: "absolute",
              top: "6px",
              left: "6px",
              width: "1.5px",
              height: "5px",
              background: "#7c3aed",
              opacity: 0.5,
              borderRadius: "2px",
            }}
          />
          {/* Child node */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              background: "#7c3aed",
            }}
          />
        </div>

        <span
          style={{
            fontSize: "10px",
            fontWeight: 500,
            color: "#a78bfa",
            display: "flex",
            alignItems: "center",
            gap: "3px",
          }}
        >
          <LinkIcon size={10} />
          {unit || "sub"}
        </span>
      </div>
    </>
  );
};
